module.exports = __webpack_public_path__ + "static/media/fvs_valve1_21.fb5e3164.jpg";